import { ITWOptionData, TWOption } from '@aclass/admin/storage/models/tw.option';
import { Attr, Model, One } from '@aclass/core/decorators/orm.decorator';
import { Model as Entity } from 'redux-orm';

export interface ITWHotelOptionData {

    readonly id: number;

    readonly type: string;

    readonly optionId: ITWOptionData['id'];
}

@Model({
    name: 'TWHotelOption'
})
export class TWHotelOption extends Entity<ITWHotelOptionData> {

    @Attr() readonly id: number;

    @Attr() readonly type: string;

    @One({ to: 'TWOption', relatedName: 'hotelOption' }) readonly optionId: TWOption;
}
